export const AEM_FUNCTIONS = {
    image: 'yme/components/image',
    elvisImage: 'yme/components/elvis-image',
    eventsHeroSection: 'yme/components/events/hero-section',
    video: 'yme/components/video',
    footerMenu: 'yme/components/footer/footer-menu',
    footerBottomMenu: 'yme/components/footer/footer-bottom-menu',
    headerMenu: 'yme/components/header/header-menu',
    productCard: 'yme/components/product-card',
    partsAndAccessoriesProductCard: 'yme/components/parts-accessories-merch-product-card',
    productDetailsPage: 'yme/components/pages/product-details-page',
    accessoriesProductDetailsPage: 'yme/components/pages/accessories-product-details-page',
    clothingProductDetailsPage: 'yme/components/pages/clothing-and-merchandise-product-details-page',
    pdpHeroSection: 'yme/components/pdp-hero-section',
    customersAlsoBought: 'yme/components/customers-also-bought',
    cookieManagement: 'yme/components/cookie-management',
    cookieTable: 'yme/components/cookie-table',
    cookieText: 'yme/components/cookie-text',
    partsAccessories: 'yme/components/parts-accessories',
    productVideo: 'yme/components/product-video',
    specifications: 'yme/components/specifications',
    accordion: 'yme/components/accordion',
    appSection: 'yme/components/app-section',
    separator: 'yme/components/separator',
    text: 'yme/components/text',
    embed: 'yme/components/embed',
    dealerLocator: 'yme/components/dealer-locator',
    dataTable: 'yme/components/data-table',
    productDisclaimer: 'yme/components/product-disclaimer',
    productFeatures: 'yme/components/product-features',
    longIntroductionSection: 'yme/components/long-introduction-section',
    discoverNew: 'yme/components/discover-new',
    specialsOffers: 'yme/components/special-offers',
    bestSellers: 'yme/components/best-sellers',
    error403: 'yme/components/error-403',
    error404: 'yme/components/error-404-hero-section',
    headerContainer: 'yme/components/containers/header-container',
    homeHeroSection: 'yme/components/home-hero-section',
    requestTestRide: 'yme/components/request-test-ride',
    testRideCLPGrid: 'yme/components/grid/test-ride-clp-grid',
    testRidePLPGrid: 'yme/components/grid/test-ride-plp-grid',
    testRideHeroSection: 'yme/components/test-ride-hero-section',
    testRideForm: 'yme/components/test-ride-form',
    upcomingEvents: 'yme/components/upcoming-events',
    mainContainer: 'yme/components/containers/main-container',
    footerContainer: 'yme/components/containers/footer-container',
    faqMainContent: 'yme/components/faq-main-content',
    ownerManuals: 'yme/components/owner-manuals',
    experienceFragment: 'yme/components/experiencefragment',
    newsHeroSection: 'yme/components/news-hero-section',
    teasers: 'yme/components/news/teasers',
    aBTestingBanner: 'yme/components/a-b-testing-banner',
    textBlock: 'yme/components/text-block',
    button: 'yme/components/button',
    newsEventsVideo: 'yme/components/news-events-video',
    gallery: 'yme/components/gallery',
    accessoriesGallery: 'yme/components/accessories-gallery',
    comparison: 'yme/components/comparison',
    checkoutForm: 'yme/components/checkout-form',
    forOwners: 'yme/components/for-owners',
    forOwnersPDPCard: 'yme/components/for-owners-pdp-card',
    forOwnersPDPPlaceholder: 'yme/components/for-owners-pdp-placeholder',
    techHighlights: 'yme/components/tech-highlights',
    twoColumnsTable: 'yme/components/two-columns-table',
    imageWithDescription: 'yme/components/image-with-description',
    imageWithText: 'yme/components/image-with-text',
    centeredImage: 'yme/components/centered-image',
    quote: 'yme/components/quote',
    downloadSection: 'yme/components/download-section',
    contentHeroSection: 'yme/components/content-hero-section',
    checkoutContent: 'yme/components/checkout-content',
    copyriphtContent: 'yme/components/copyright-info',
    productPricingInfo: 'yme/components/product-pricing-info',
    promotionalBannerPdpCard: 'yme/components/promotional-banner-pdp-card',
    promotionalBannerPdpPlaceholder: 'yme/components/promotional-banner-pdp-placeholder',
    contentPreviewCard: 'yme/components/content-preview-card',
    offerCard: 'yme/components/megamenu/offers',
    featuredHere: 'yme/components/featured-here',
    tags: 'yme/components/tags',
    searchResults: 'yme/components/global-search-results',
    cardsList: 'yme/components/cards-list',
    twoCards: 'yme/components/two-cards',
    whatToReadNext: 'yme/components/what-to-read-next',
    threeColumnsWithTopImages: 'yme/components/three-columns-with-top-images',
    cardsWithTitles: 'yme/components/cards-with-titles',
    highlightingCard: 'yme/components/highlighting-card',
    categorySelectorPanel: 'yme/components/category-selector-panel',
    promoSection: 'yme/components/promo-section',
    productCardsSection: 'yme/components/product-cards-section',
    newsGrid: 'yme/components/grid/news-grid',
    eventsGrid: 'yme/components/grid/events-grid',
    latestNews: 'yme/components/latest-news',
    clpHeroSection: 'yme/components/clp-hero-section',
    slpHeroSection: 'yme/components/slp-hero-section',
    clpUnitsGrid: 'yme/components/grid/clp-units-grid',
    plpAccessoriesGrid: 'yme/components/grid/plp-accessories-grid',
    plpClothingMerchGrid: 'yme/components/grid/plp-clothing-merch-grid',
    plpUnitsGrid: 'yme/components/grid/plp-units-grid',
    segmentSelectorPanel: 'yme/components/segment-selector-panel',
    iframe: 'yme/components/iframe',
    categoryPreviewSection: 'yme/components/category-preview-section',
    descriptionFaq: 'yme/components/parts-accessories-merch-product-description-faq',
    cookieBanner: 'yme/components/cookie-banner',
    dealerLocatorPage: 'yme/components/dealer-locator-form',
    returnForm: 'yme/components/return-form',
    titleWithSubtitle: 'yme/components/title-with-subtitle',
    cookieList: 'yme/components/cookie-list',
    leadForm: 'yme/components/lead-generation-form',
    newsletterSubscriptionConfirmation: 'yme/components/newsletter-subscription-confirmation',
    maintenanceForm: 'yme/components/maintenance-form',
    // Offers Promo
    offersPromoHeroSection: 'yme/components/offers-promo-hero-section',
    wcmMsmGhost: 'wcm/msm/components/ghost',
    offersPromoGrid: 'yme/components/grid/offers-promo-grid',
    // Destinations
    experienceDetailsPage: 'yme/components/pages/experience-details-page',
    experienceDetailsCard: 'yme/components/destinations/experience-details-card',
    unitRelatedExperiences: 'yme/components/destinations/unit-related-experiences',
    experienceRelatedUnits: 'yme/components/destinations/experience-related-units',
    experienceGrid: 'yme/components/grid/experiences-grid',
    experienceRelatedExperiences: 'yme/components/destinations/experience-related-experiences',
    partnersGrid: 'yme/components/grid/partners-grid',
    partnerDetailsPage: 'yme/components/pages/partner-details-page',
    partnerDetailsCard: 'yme/components/destinations/partner-details-card',
    partnerRelatedExperiences: 'yme/components/destinations/partner-related-experiences',
    ambassadorsGrid: 'yme/components/grid/ambassadors-grid',
    ambassadorDetailsPage: 'yme/components/pages/ambassador-details-page',
    ambassadorDetailsCard: 'yme/components/destinations/ambassador-details-card',
    ambassadorRelatedExperiences: 'yme/components/destinations/ambassador-related-experiences',
    wishlistGrid: 'yme/components/grid/wishlist-grid',
    rentalLocatorForm: 'yme/components/rental-locator-form',
    consentsSubscriptionConfirmation: 'yme/components/consents-subscription-confirmation',
};
